$(document).ready(function () {
    var restrict = $('.restrict');
    var restrictions = $('.restrictions');
    var tomorrow = dayjs().add('1', 'day').format(DATE_TIME_PICKER_FORMAT);
    var today = dayjs().unix();
    var restriction_group_id = 0;

    $(restrict).find('input[type="radio"][name="restricted"]').change(function () {
        if ($(this).val() == 0) {
            $(restrictions).hide();
        } else {
            $(restrictions).show();
        }
    });

    /**
    *
    * @param object  restriction  a restriction object {group: int groupID, start: int end: int, id: int restrictionID}
    *
    * @return undefined
    *
    * This function is responsible for stamping out the restriction boxes and binding all the required event handlers.
    *
    * This is done within here to encapsulate the event handlers and ensure that they all only pertain to the correct
    * restriction instance(rather than bleeding out and affecting other restrictions).
    */
    function addRestriction(restriction) {
        var template = $('.template').clone();
        var start = $(template).find('.start.date');
        var end = $(template).find('.end.date');
        var endDateCheckBox = $(end).siblings('span.input-group-addon').find('input[type="checkbox"]');
        var group = $(template).find('.restriction__group');
        var restriction_id = $(template).find('.restriction__id');

        // Set the field values if we provided a restriction object to the function
        if (restriction) {
            // Check for restriction groups already assigned, which don't exist in the select list for the current academic year
            if ($('option[value="' + restriction.group  + '"]').length == 0) {
                $(group).append($('<optgroup>').prop('label', restriction.acyr)
                    .append($('<option>', {
                        value: restriction.group,
                        text: restriction.groupname,
                    })));
            }

            $(group).find('option[value="' + restriction.group + '"]').prop('selected', true);
            $(group).prop('name', 'restrictions[' + restriction_group_id + '][groups_id]');

            $(start).prop('name', 'restrictions[' + restriction_group_id + '][availablefrom]');
            $(end).prop('name', 'restrictions[' + restriction_group_id + '][availableto]');

            if (dayjs.unix(restriction.start).isValid()) {
                $(start).val(dayjs.unix(restriction.start).format(DATE_TIME_PICKER_FORMAT));
            }
            if (dayjs.unix(restriction.end).isValid()) {
                $(end).val(dayjs.unix(restriction.end).format(DATE_TIME_PICKER_FORMAT));
            }
            if (restriction.id !== undefined) {
                $(restriction_id).prop('name', 'restrictions[' + restriction_group_id + '][id]').val(restriction.id);
            }
            if (restriction.end !== undefined && restriction.end !== null) {
                $(endDateCheckBox).prop('checked', true);
                $(end).removeAttr('disabled');
            } else {
                $(end).val(tomorrow);
            }
        }

        // Bind an event handler to make the remove button work
        $(template).on('click', '.restriction__remove', function () {
            $(this).parents('.restriction').remove();
        });

        // Bind an event handler to show the date picker for the start time box
        $(template).find(start).datetimepicker({
            scrollMonth: false,
            endDate: dayjs().format(DATE_PICKER_FORMAT),
            onChangeDateTime: function (startDateTime) {
                startDateTime = dayjs(startDateTime);
                $(end).val(null);
                var minTime;
                var minDate;
                if (startDateTime.hour() >= 23 && startDateTime.minute() > 30) {
                    minDate = startDateTime.add(1, 'day').format(DATE_PICKER_FORMAT);
                    minTime = '00:00';
                } else {
                    minDate = startDateTime.format(DATE_PICKER_FORMAT);
                    minTime = startDateTime.format(TIME_PICKER_FORMAT);
                }
                $(end).datetimepicker({
                    minDate: minDate,
                    startDate: minDate,
                    minTime: minTime,
                    onChangeDateTime: function (endDateTime) {
                        endDateTime = dayjs(endDateTime);
                        if (startDateTime.format(DATE_PICKER_FORMAT) == endDateTime.format(DATE_PICKER_FORMAT)) {
                            $(end).datetimepicker({ minTime: startDateTime.format(TIME_PICKER_FORMAT) });
                        } else {
                            $(end).datetimepicker({ minTime: '00:00' });
                        }
                    },
                });
            },
        });

        $(template).find(endDateCheckBox).change(function () {
            if ($(this).is(':checked')) {
                $(this).parents('.restriction').find(end).removeAttr('disabled');
                var minTime;
                var minDate;
                var startDateTime = dayjs($(restrict).find(start).val());
                if (startDateTime.hour() >= 23 && startDateTime.minute() > 30) {
                    minDate = startDateTime.add(1, 'day').format(DATE_PICKER_FORMAT);
                    minTime = '00:00';
                } else {
                    minDate = startDateTime.format(DATE_PICKER_FORMAT);
                    minTime = startDateTime.format(TIME_PICKER_FORMAT);
                }
                $(end).datetimepicker({
                    minDate: minDate,
                    minTime: minTime,
                    startDate: minDate,
                    onChangeDateTime: function (endDateTime) {
                        endDateTime = dayjs(endDateTime);
                        if (startDateTime.format(DATE_PICKER_FORMAT) == endDateTime.format(DATE_PICKER_FORMAT)) {
                            $(end).datetimepicker({ minTime: startDateTime.format(TIME_PICKER_FORMAT) });
                        } else {
                            $(end).datetimepicker({ minTime: '00:00' });
                        }
                    },
                });
            } else {
                $(this).parents('.restriction').find(end).val(null).prop('disabled', true);
            }
        });

        // Stamp the template out
        $(template).removeClass('hide').removeClass('template').insertBefore('.restriction.add');
        restriction_group_id += 1;
    }

    // Click handler responsible for stamping out the template
    $(restrictions).find('.restriction.add').click(function () {
        addRestriction({
            group: 0,
            start: today,
            end: null,
            id: undefined,
        });
    });

    if (typeof resourceRestrictions !== 'undefined' && resourceRestrictions.length > 0) {
        for (const resourceRestriction of resourceRestrictions) {
            addRestriction({
                group: resourceRestriction.groups_id,
                groupname: resourceRestriction.groupname,
                acyr: resourceRestriction.acyr,
                start: resourceRestriction.availablefrom,
                end: resourceRestriction.availableto,
                id: resourceRestriction.id,
            });
        }
    }

    $('.resource-type li a').on('shown.bs.tab', function () {
        $('input[type="hidden"][name="type"]').val($(this).data('type'));
    });
});
